import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var Filter = createSvgIcon(React__default.createElement("path", { clipRule: "evenodd", d: "M10.83 7H21V5H10.83a3.001 3.001 0 0 0-5.66 0H3v2h2.17a3.001 3.001 0 0 0 5.66 0ZM8 15a3.001 3.001 0 0 0-2.83 2H3v2h2.17a3.001 3.001 0 0 0 5.66 0H21v-2H10.83A3.001 3.001 0 0 0 8 15Zm1-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10.83-8a3.001 3.001 0 0 0-5.66 0H3v2h10.17a3.001 3.001 0 0 0 5.66 0H21v-2h-2.17ZM15 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z", fillRule: "evenodd" }), 'Filter');

export { Filter };
